// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"89a4664c","479":"cb295cbf","849":"bcd28097","881":"6cecaf56"}[chunkId] + ".chunk.css";
};